
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum OnHoldReason {
	PaymentArrangementAgreed = 1,
	WorkingOnResolution = 2,
	Settlement = 3,
	DebtCollection = 4,
	Objection = 5
}
export namespace OnHoldReason {
	export function getKeys(): Map<OnHoldReason, string> {
		return new Map([[1, 'PaymentArrangementAgreed'], [2, 'WorkingOnResolution'], [3, 'Settlement'], [4, 'DebtCollection'], [5, 'Objection']]);
	}
}
